import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../../component/Sidebar/Sidebar';
import Header from '../../component/Header/Header';

function useAuth() {
  const token = localStorage.getItem('token');
  return token != null;
}

export default function ProtectedRoute() {
  const isAuthenticated = useAuth(); // Or use your isAuthenticated logic

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <Header />
      <div className="app-layout">
        <Sidebar />
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </>
  );
}

